module.exports = __webpack_public_path__ + "img/companion-sys-tray.d2865b3e.jpg";